import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/nfts/featured1.jpg'
import _imports_1 from '@/assets/images/nfts/author.gif'
import _imports_2 from '@/assets/images/nfts/verified2.svg'
import _imports_3 from '@/assets/images/nfts/featured2.jpg'
import _imports_4 from '@/assets/images/nfts/featured3.jpg'
import _imports_5 from '@/assets/images/nfts/featured4.jpg'
import _imports_6 from '@/assets/images/nfts/featured5.jpg'
import _imports_7 from '@/assets/images/nfts/featured6.gif'
import _imports_8 from '@/assets/images/nfts/featured7.jpg'
import _imports_9 from '@/assets/images/nfts/featured8.jpg'


const _hoisted_1 = { class: "trezo-card mb-[25px]" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-[25px]" }
const _hoisted_4 = { class: "nft-card bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_5 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_6 = { class: "flex items-center gap-[6px]" }
const _hoisted_7 = { class: "nft-card bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_8 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_9 = { class: "flex items-center gap-[6px]" }
const _hoisted_10 = { class: "nft-card bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_11 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_12 = { class: "flex items-center gap-[6px]" }
const _hoisted_13 = { class: "nft-card bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_14 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_15 = { class: "flex items-center gap-[6px]" }
const _hoisted_16 = { class: "nft-card bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_17 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_18 = { class: "flex items-center gap-[6px]" }
const _hoisted_19 = { class: "nft-card bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_20 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_21 = { class: "flex items-center gap-[6px]" }
const _hoisted_22 = { class: "nft-card bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_23 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_24 = { class: "flex items-center gap-[6px]" }
const _hoisted_25 = { class: "nft-card bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_26 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_27 = { class: "flex items-center gap-[6px]" }
const _hoisted_28 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_29 = { class: "trezo-card-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "rounded-md mb-[12px]",
                alt: "nft-image"
              }),
              _createElementVNode("button", {
                class: "bid-btn absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[15px] md:text-md rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[20px] transition-all hover:bg-primary-400 inline-block",
                type: "button"
              }, " Place Bid ")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "rounded-full w-[27px]",
                  alt: "author-image"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "block text-xs" }, " NFT ID: 35246 ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode(" Christmas Eve ")
                    ])),
                    _: 1,
                    __: [0]
                  })
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                src: _imports_2,
                alt: "verified"
              }, null, -1))
            ]),
            _cache[5] || (_cache[5] = _createStaticVNode("<span class=\"block text-xs mb-[4px]\" data-v-1dd86a82> Highest Bid: <span class=\"font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]\" data-v-1dd86a82>9.75 ETH</span></span><div class=\"flex items-center justify-between pb-[5px]\" data-v-1dd86a82><span class=\"block font-semibold text-primary-800\" data-v-1dd86a82> 5.50 ETH </span><span class=\"block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]\" data-v-1dd86a82><i class=\"ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg\" data-v-1dd86a82></i><span class=\"text-gray-900 dark:text-gray-400\" data-v-1dd86a82>9.2/</span>10 </span></div>", 2))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_3,
                class: "rounded-md mb-[12px]",
                alt: "nft-image"
              }),
              _createElementVNode("button", {
                class: "bid-btn absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[15px] md:text-md rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[20px] transition-all hover:bg-primary-400 inline-block",
                type: "button"
              }, " Place Bid ")
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "rounded-full w-[27px]",
                  alt: "author-image"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "block text-xs" }, " NFT ID: 35247 ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode(" Humming Bird ")
                    ])),
                    _: 1,
                    __: [6]
                  })
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("img", {
                src: _imports_2,
                alt: "verified"
              }, null, -1))
            ]),
            _cache[11] || (_cache[11] = _createStaticVNode("<span class=\"block text-xs mb-[4px]\" data-v-1dd86a82> Highest Bid: <span class=\"font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]\" data-v-1dd86a82>10.75 ETH</span></span><div class=\"flex items-center justify-between pb-[5px]\" data-v-1dd86a82><span class=\"block font-semibold text-primary-800\" data-v-1dd86a82> 12.50 ETH </span><span class=\"block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]\" data-v-1dd86a82><i class=\"ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg\" data-v-1dd86a82></i><span class=\"text-gray-900 dark:text-gray-400\" data-v-1dd86a82>9.5/</span>10 </span></div>", 2))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_4,
                class: "rounded-md mb-[12px]",
                alt: "nft-image"
              }),
              _createElementVNode("button", {
                class: "bid-btn absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[15px] md:text-md rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[20px] transition-all hover:bg-primary-400 inline-block",
                type: "button"
              }, " Place Bid ")
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[14] || (_cache[14] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "rounded-full w-[27px]",
                  alt: "author-image"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "block text-xs" }, " NFT ID: 35228 ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode(" Naughty Pool ")
                    ])),
                    _: 1,
                    __: [12]
                  })
                ])
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("img", {
                src: _imports_2,
                alt: "verified"
              }, null, -1))
            ]),
            _cache[17] || (_cache[17] = _createStaticVNode("<span class=\"block text-xs mb-[4px]\" data-v-1dd86a82> Highest Bid: <span class=\"font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]\" data-v-1dd86a82>8.75 ETH</span></span><div class=\"flex items-center justify-between pb-[5px]\" data-v-1dd86a82><span class=\"block font-semibold text-primary-800\" data-v-1dd86a82> 9.50 ETH </span><span class=\"block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]\" data-v-1dd86a82><i class=\"ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg\" data-v-1dd86a82></i><span class=\"text-gray-900 dark:text-gray-400\" data-v-1dd86a82>9.7/</span>10 </span></div>", 2))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_5,
                class: "rounded-md mb-[12px]",
                alt: "nft-image"
              }),
              _createElementVNode("button", {
                class: "bid-btn absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[15px] md:text-md rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[20px] transition-all hover:bg-primary-400 inline-block",
                type: "button"
              }, " Place Bid ")
            ], -1)),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[20] || (_cache[20] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "rounded-full w-[27px]",
                  alt: "author-image"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "block text-xs" }, " NFT ID: 35227 ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode(" Hello Thumbs ")
                    ])),
                    _: 1,
                    __: [18]
                  })
                ])
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("img", {
                src: _imports_2,
                alt: "verified"
              }, null, -1))
            ]),
            _cache[23] || (_cache[23] = _createStaticVNode("<span class=\"block text-xs mb-[4px]\" data-v-1dd86a82> Highest Bid: <span class=\"font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]\" data-v-1dd86a82>9.30 ETH</span></span><div class=\"flex items-center justify-between pb-[5px]\" data-v-1dd86a82><span class=\"block font-semibold text-primary-800\" data-v-1dd86a82> 8.15 ETH </span><span class=\"block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]\" data-v-1dd86a82><i class=\"ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg\" data-v-1dd86a82></i><span class=\"text-gray-900 dark:text-gray-400\" data-v-1dd86a82>9.3/</span>10 </span></div>", 2))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_6,
                class: "rounded-md mb-[12px]",
                alt: "nft-image"
              }),
              _createElementVNode("button", {
                class: "bid-btn absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[15px] md:text-md rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[20px] transition-all hover:bg-primary-400 inline-block",
                type: "button"
              }, " Place Bid ")
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[26] || (_cache[26] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "rounded-full w-[27px]",
                  alt: "author-image"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "block text-xs" }, " NFT ID: 35248 ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode(" Pixel Watermelon ")
                    ])),
                    _: 1,
                    __: [24]
                  })
                ])
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("img", {
                src: _imports_2,
                alt: "verified"
              }, null, -1))
            ]),
            _cache[29] || (_cache[29] = _createStaticVNode("<span class=\"block text-xs mb-[4px]\" data-v-1dd86a82> Highest Bid: <span class=\"font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]\" data-v-1dd86a82>1.75 ETH</span></span><div class=\"flex items-center justify-between pb-[5px]\" data-v-1dd86a82><span class=\"block font-semibold text-primary-800\" data-v-1dd86a82> 3.50 ETH </span><span class=\"block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]\" data-v-1dd86a82><i class=\"ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg\" data-v-1dd86a82></i><span class=\"text-gray-900 dark:text-gray-400\" data-v-1dd86a82>9.1/</span>10 </span></div>", 2))
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_7,
                class: "rounded-md mb-[12px]",
                alt: "nft-image"
              }),
              _createElementVNode("button", {
                class: "bid-btn absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[15px] md:text-md rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[20px] transition-all hover:bg-primary-400 inline-block",
                type: "button"
              }, " Place Bid ")
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[32] || (_cache[32] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "rounded-full w-[27px]",
                  alt: "author-image"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("span", { class: "block text-xs" }, " NFT ID: 35258 ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                      _createTextVNode(" BDancing Cookies ")
                    ])),
                    _: 1,
                    __: [30]
                  })
                ])
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("img", {
                src: _imports_2,
                alt: "verified"
              }, null, -1))
            ]),
            _cache[35] || (_cache[35] = _createStaticVNode("<span class=\"block text-xs mb-[4px]\" data-v-1dd86a82> Highest Bid: <span class=\"font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]\" data-v-1dd86a82>10.75 ETH</span></span><div class=\"flex items-center justify-between pb-[5px]\" data-v-1dd86a82><span class=\"block font-semibold text-primary-800\" data-v-1dd86a82> 12.50 ETH </span><span class=\"block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]\" data-v-1dd86a82><i class=\"ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg\" data-v-1dd86a82></i><span class=\"text-gray-900 dark:text-gray-400\" data-v-1dd86a82>9.1/</span>10 </span></div>", 2))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_8,
                class: "rounded-md mb-[12px]",
                alt: "nft-image"
              }),
              _createElementVNode("button", {
                class: "bid-btn absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[15px] md:text-md rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[20px] transition-all hover:bg-primary-400 inline-block",
                type: "button"
              }, " Place Bid ")
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[38] || (_cache[38] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "rounded-full w-[27px]",
                  alt: "author-image"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[37] || (_cache[37] = _createElementVNode("span", { class: "block text-xs" }, " NFT ID: 35158 ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                      _createTextVNode(" Rotating Flower ")
                    ])),
                    _: 1,
                    __: [36]
                  })
                ])
              ]),
              _cache[39] || (_cache[39] = _createElementVNode("img", {
                src: _imports_2,
                alt: "verified"
              }, null, -1))
            ]),
            _cache[41] || (_cache[41] = _createStaticVNode("<span class=\"block text-xs mb-[4px]\" data-v-1dd86a82> Highest Bid: <span class=\"font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]\" data-v-1dd86a82>3.95 ETH</span></span><div class=\"flex items-center justify-between pb-[5px]\" data-v-1dd86a82><span class=\"block font-semibold text-primary-800\" data-v-1dd86a82> 6.50 ETH </span><span class=\"block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]\" data-v-1dd86a82><i class=\"ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg\" data-v-1dd86a82></i><span class=\"text-gray-900 dark:text-gray-400\" data-v-1dd86a82>8.7/</span>10 </span></div>", 2))
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                src: _imports_9,
                class: "rounded-md mb-[12px]",
                alt: "nft-image"
              }),
              _createElementVNode("button", {
                class: "bid-btn absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[15px] md:text-md rounded-[4px] bg-primary-500 text-white font-medium py-[7px] px-[20px] transition-all hover:bg-primary-400 inline-block",
                type: "button"
              }, " Place Bid ")
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[44] || (_cache[44] = _createElementVNode("img", {
                  src: _imports_1,
                  class: "rounded-full w-[27px]",
                  alt: "author-image"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _cache[43] || (_cache[43] = _createElementVNode("span", { class: "block text-xs" }, " NFT ID: 35782 ", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                      _createTextVNode(" Flying Bulb ")
                    ])),
                    _: 1,
                    __: [42]
                  })
                ])
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("img", {
                src: _imports_2,
                alt: "verified"
              }, null, -1))
            ]),
            _cache[47] || (_cache[47] = _createStaticVNode("<span class=\"block text-xs mb-[4px]\" data-v-1dd86a82> Highest Bid: <span class=\"font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]\" data-v-1dd86a82>8.75 ETH</span></span><div class=\"flex items-center justify-between pb-[5px]\" data-v-1dd86a82><span class=\"block font-semibold text-primary-800\" data-v-1dd86a82> 9.50 ETH </span><span class=\"block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]\" data-v-1dd86a82><i class=\"ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg\" data-v-1dd86a82></i><span class=\"text-gray-900 dark:text-gray-400\" data-v-1dd86a82>9.7/</span>10 </span></div>", 2))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_Pagination, {
          total: "30",
          items: "8",
          class: "pt-[0] md:pt-[0]"
        })
      ])
    ])
  ], 64))
}